/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"
import dsgvo from "./dsgvo"
import imprint from "./imprint"
import Header from "./header"
import "bulma/css/bulma.min.css"
import "./layout.css"
import "./fonts.css"
import "flexboxgrid"
import "./overlay.css"

import Claimer from "./claimer"
import Footer from "./Footer"

const Layout = ({ children, onScroll }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  // which legal document is open: null | "imprint" | "gdpr"
  const [legal, setLegal] = useState(null)

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "100%",
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
      }}
      onScroll={onScroll}
    >
      <Header siteTitle={data.site.siteMetadata.title} />
      <div className={"main-wrapper"}>
        <Claimer open={() => setLegal("gdpr")} />
        <main>{children}</main>
        <Footer
          title={data.site.siteMetadata.title}
          onImprint={() => setLegal("imprint")}
          onGdpr={() => setLegal("gdpr")}
        />
        {legal && (
          <div
            className="overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 100,
              overflowY: "auto",
            }}
          >
            <button
              type="button"
              className="overlay-close"
              onClick={() => setLegal(null)}
              aria-label="close"
            >
              <svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true">
                <line x1="3" y1="3" x2="21" y2="21" stroke="currentColor" strokeWidth="1.2" />
                <line x1="21" y1="3" x2="3" y2="21" stroke="currentColor" strokeWidth="1.2" />
              </svg>
            </button>
            <div className="overlay-content overlay-legal">
              {legal === "imprint" ? imprint() : dsgvo()}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
